module.exports = __webpack_public_path__ + "static/img/RZ_pic07.e109801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic07.png
// module id = zGBu
// module chunks = 5